/*!
=========================================================
* 支払
=========================================================
*/
import React from "react";

import {
  Button,
  Table, Row, Col,
  Label,
} from "reactstrap";

import Request from '../../common/Request';
import DialogBase from '../Base/DialogBase';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import Format from '../../common/Format';
import CsvDownloader from "react-csv-downloader";
import CustomTd from '../ViewParts/CustomTd';
import InputText from '../FormParts/InputText';
import InputDatetime from '../FormParts/InputDatetime';
import InputCheckBox from '../FormParts/InputCheckBox';
import InputSelect from '../FormParts/InputSelect';
import InputRadio from '../FormParts/InputRadio';
import InputNumber from '../FormParts/InputNumber';
import {
  cst_payment_status,
  cst_payment_status_search,
  cst_payment_type,
  cst_payment_bank_account_type
} from '../../variables/codes_map';
import FormatCode from '../../common/FormatCode';
import 'moment/locale/ja';
import WithRole from '../FormParts/ButtonWithRole';
import Definition from '../../common/Definition';
import OptionConvert from '../../common/OptionConvert';
import { GetMessage, getErrorCodes } from "../../variables/message";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import { ZEN_FURI, PAYMENT_CSV } from '../../variables/csv'
import { sortByNumber } from "../../common/Sort"
import GoogleDrive from "../../common/GoogleDrive"
import Encoding from 'encoding-japanese';
import Validate from '../../common/Validate';
import _ from 'underscore';
import { postAccountsLog } from "../../common/PostAccountsLog";

const moment = require("moment");

class List extends ListBase {
  default_column = [
    { Header: '対象見積ID',accessor: 'estimate_natural_id_ssv',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '契約期間',accessor: '___JOIN_quote_available_date_payment',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '振込先（支払）',accessor: '___JOIN_payment_bank',headerClassName:'text-center',className:'text-left text-top',width:160,minWidth:50},
    { Header: '銀行コード',accessor: 'PAYMENT__bank_natural_id',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50},
    { Header: '支払依頼日時',accessor: 'PAYMENT__payment_date',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50, sortMethod: sortByNumber },
    { Header: '仕入支払期日',accessor: 'PAYMENT__payment_limit_date',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50, sortMethod: sortByNumber },
    { Header: '支払金額',accessor: 'PAYMENT__payment_amt',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50, sortMethod: sortByNumber },
    // { Header: '敷金',accessor: 'ESTIMATE__quote_cost_security_deposit_total_amt',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50},
    { Header: '経理課への仕入メモ（仕入依頼時に入力）',accessor: 'PAYMENT__payment_user_memo',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50,isResizing:true},
    { Header: '仕入状況',accessor: 'PAYMENT__payment_status',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50},
    { Header: '仕入実施日',accessor: 'PAYMENT__payment_finish_date',headerClassName:'text-center',className:'text-left text-top',width:130,minWidth:50},
    { Header: '弊社担当者',accessor: 'PAYMENT__user_name',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50},
    { Header: '差戻処理',accessor: 'actions_2',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '仕入追金',accessor: 'actions_3',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '追金確認済',accessor: 'actions_4',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '賃料支払先',accessor: 'ESTIMATE__survey_cost_parking_rent',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '手数料支払先',accessor: 'ESTIMATE__survey_cost_commission',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '礼金支払先',accessor: 'ESTIMATE__survey_cost_key_money',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '支払',
      add_url: '',
      //search_url: '/api/payment',
      search_url: '/api/payment/unlimit',

      checked_payment : "",
      with_all_check: true,

      column: this.default_column,
      detail_search:false,
      show_detail_search_field:false,
      searchData:{
        values:{
          payment_status : ["1","3","5"] // 検索条件の初期表示：仕入状況の初期設定
        },
        errors:{},
        requiredData:{}
      },
      executionData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogAddCostData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogAddCostConfirmData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      error_modal:"",
      error_message:"",
      checkedData:[],
      runData:[],
      csvData:[],
      checkbox_field_in_table:true,
      auto_scroll:true,
      unique_key:"PAYMENT__id",
    });

    this.dialogConfirm = React.createRef();
    this.dialogPaymentConfirm = React.createRef();
    this.dialogAddCost = React.createRef();
    this.dialogAddCostConfirm = React.createRef();
    this.dialogInvoiceCsvDownload = React.createRef();
    this.dialogPaymentBankUpdate = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.returnStatus = this.returnStatus.bind(this)
    this.PaymentBankUpdate = this.PaymentBankUpdate.bind(this)
    this.onClickExecButton = this.onClickExecButton.bind(this)
    this.validateExecCallback = this.validateExecCallback.bind(this)
    this.getButtonIdByExecutionType = this.getButtonIdByExecutionType.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
    this.convertKouzaKana = this.convertKouzaKana.bind(this)
    this.convertKouzaNum = this.convertKouzaNum.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.options(res.Data)
      this.setState({
        landmark_user:user_list
      },()=>this.search(false));
    })

    // BizStationフォーマット対応（銀行名ｶﾅ、支店名ｶﾅ）
    Request.get('/api/bank', {}, res=>{
      this.setState({
        bankList:res.Data,
        bankListModal:res.Data.map(element=>{
          return {
            value:element.bank_natural_id,
            label:element.bank_name
          }
        })
      });
    })
    Request.get('/api/bank/branch', {}, res=>{
      this.setState({
        bankBranchList:res.Data,
        bankBranchListModal:res.Data.map(element=>{
          return {
            value:element.bank_branch_natural_id,
            label:element.bank_branch_name,
            bank_natural_id:element.bank_natural_id
          }
        })
      });
    })
  }

  dataMap(data) {
    const user_list = this.state.landmark_user;
    
    return data.map((prop, key) => {
      const matchedUser = user_list.find((singleUser)=>singleUser.id===prop.payment_user_id)
      const payment_user = matchedUser ? (
        {
          name:matchedUser.label,
          picture:matchedUser.picture,
          ulid:matchedUser.id,
          id:matchedUser.value
        }
      ):(
        {
          name:"",
          picture:"",
          ulid:"",
          id:""
        }
      )
      const prop_tmp = {user_name:payment_user.name, update_timestamp:prop.update_timestamp};
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)

      const invoice_pdf_urls = prop.invoice_pdf_urls && prop.invoice_pdf_urls.split(',').reduce((acc, item) => {
        const invoice_pdf_url = item.split('|');
        return {
          ...acc,
          [invoice_pdf_url[0]]:invoice_pdf_url[1]
        }
      }, {})

      const estimate_natural_id_ssv_split = prop.estimate_natural_id_ssv.split(',');
      console.log(data)

      return {
        prop,
        id: prop.id,
        estimate_natural_id_ssv: 
        <>
          {
            estimate_natural_id_ssv_split.map((item, index, row) => {
              const isLast = index + 1 === row.length;
              // console.log("invoice_pdf_urls[item]  ", invoice_pdf_urls &&  invoice_pdf_urls[item] )
              return <>{
                invoice_pdf_urls && invoice_pdf_urls[item] 
                ? <><a href={`/api/gcs_download/${invoice_pdf_urls[item]}?open=1`} target="_blank">{item}</a>{!isLast && ","}</>
                : <span>{item}{!isLast && ","}</span>
              }</>
            })
          }
        </>,
        ___JOIN_quote_available_date_payment:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date_payment', prop)}} />,
        ___JOIN_payment_bank: (<>
        <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_bank', prop)}} />
        <ButtonWithRole button_id="BTN_G1_01_03347" 
                        size="sm" 
                        onClick={()=>this.PaymentBankUpdate(prop)} 
                        className="text-center" 
                        disabled={!((prop.payment_status == 1 || prop.payment_status == 3|| prop.payment_status == 5) && prop.payment_type == 0)}>振込先変更</ButtonWithRole>  
        </>
        ),
        PAYMENT__bank_natural_id : (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_bank_code', prop)}} />),
        PAYMENT__payment_date: Format.format_date(prop.payment_date),
        PAYMENT__payment_limit_date: Format.format_date(prop.payment_limit_date),
        PAYMENT__payment_amt: (<div dangerouslySetInnerHTML={{__html:Format.comma_delimited(prop.payment_amt,"円") + "<br />" +  FormatCode.decode("cst_payment_type",prop.payment_type)}} />),
        // ESTIMATE__quote_cost_security_deposit_total_amt:Format.comma_delimited(prop.quote_cost_security_deposit_total_amt,"円"),
        PAYMENT__payment_user_memo: prop.payment_user_memo,
        PAYMENT__payment_status: FormatCode.decode("cst_payment_status",prop.payment_status),
        PAYMENT__payment_finish_date: Format.format_date(prop.payment_finish_date),
        PAYMENT__user_name: prop_tmp.user_name,
        actions_2: (<ButtonWithRole button_id="BTN_G1_01_03310" size="sm" onClick={()=>this.returnStatus(prop)} className="text-center" disabled={!(prop.payment_status == 1)&&!(prop.payment_status == 5)}>差戻</ButtonWithRole>),
        actions_3: (<ButtonWithRole button_id="BTN_G1_01_03345" size="sm" onClick={()=>this.setAddCostDialog(prop)} className="text-center" disabled={prop.payment_status != 4}>仕入追金</ButtonWithRole>),
        actions_4: (<ButtonWithRole button_id="BTN_G1_01_03346" size="sm" onClick={()=>this.setAddCostConfirmDialog(prop)} className="text-center" disabled={prop.add_cost_check_flag != 0}>追金確認済</ButtonWithRole>),
        ESTIMATE__survey_cost_parking_rent: this.map_invoice_data(prop, "survey_cost_parking_rent"),
        ESTIMATE__survey_cost_commission: this.map_invoice_data(prop, "survey_cost_commission"),
        ESTIMATE__survey_cost_key_money: this.map_invoice_data(prop, "survey_cost_key_money"),
        checked:( this.checkedForItem(prop) )? true: undefined,
      }
    });
  }

  map_invoice_data (data, param) {
    let payment_type = data[param+"_payment_type"]
    switch (payment_type) {
      // 区分：仕入先
      case 0:{
        if (data["supplier_invoice_business_type"] == null) return "未登録"
        let business_type = FormatCode.decode("cst_invoice_business_type",data["supplier_invoice_business_type"])
        return data["supplier_invoice_business_type"] == 1? business_type+"("+data["supplier_invoice_registration_number"]+")" : business_type
      }
      // 区分：その他
      case 1:{
        let business_type = data[param+"_invoice_business_type"]
        if (business_type == null) return "未登録"
        let business_type_label = FormatCode.decode("cst_invoice_business_type",business_type)
        return business_type == 1? business_type_label+"("+data[param+"_invoice_registration_number"]+")":business_type_label
      }
      default:{
        return "未登録"
      }
    }
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true,setUlid="",setData=[] ) {
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
        let checkedItems = this.state.checkedItems;
        let data = this.dataMap(res.Data);
        let tmpCheckedItems = [];        
        let tmp = "";
        if(refreshTaskFlag){
          // console.log(setData);
          if(checkedItems.length > 0){
            checkedItems.map((item,index)=>{
              tmp = data.find((d)=>d.id == item.id);
              if(tmp){
                tmpCheckedItems.push(tmp)
              }else{
                if(item.prop.ulid != setUlid && setUlid != ""){
                  tmpCheckedItems.push(item)
                }
              }
            });
          }
        }
        // console.log(tmpCheckedItems);
        this.setState({
          paging: {
            "index": parseInt(searchParmas["pager_index"]),
            "limit": parseInt(searchParmas["pager_limit"])
          },  
          data: data,
          checkedItems:tmpCheckedItems,
        });

    })
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <InputText
            label='対象見積ID'
            name='PAYMENT__estimate_natural_id_ssv'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='仕入実施日（FROM)'
            name='PAYMENT__payment_finish_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='仕入実施日（TO)'
            name='PAYMENT__payment_finish_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='CSV出力日'
            name='PAYMENT__payment_csv_upload_date'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='契約期間開始日（FROM)'
            name='ESTIMATE__quote_available_start_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='契約期間開始日（TO)'
            name='ESTIMATE__quote_available_start_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='契約期間終了日（FROM)'
            name='ESTIMATE__quote_available_end_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='契約期間終了日（TO)'
            name='ESTIMATE__quote_available_end_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputRadio options={[
            {default:0,value:0,label:"全て"},
            {value:1,label:"無"},
            {value:2,label:"有"},
          ]}
            validateCallback={this.validateCallback} 
            rootData={this.state.searchData}
            labelOn={true}
            validateType="search"
            label="銀行コード有無"
            name="PAYMENT__bank_natural_id"
            />
        </Col>
        {/* <Col md="3">
          <InputCheckBox
            label='敷金有'
            name='ESTIMATE__quote_cost_security_deposit_total_amt'
            labelOn={true}
            validateCallback={this.validateCallback}
            checkedValue={1}
            uncheckedValue={0}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col> */}
        
        <Col md="3">
          <InputCheckBox
            label='仕入状況'
            name='PAYMENT__payment_status'
            labelOn={true}
            options={cst_payment_status_search}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>

        <Col md="3">
          <InputCheckBox
            label='支払種別'
            name='PAYMENT__payment_type'
            labelOn={true}
            options={cst_payment_type}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>

        <Col md="3">
          <InputCheckBox
            label='追金未確認のみに絞る'
            name='PAYMENT__add_cost_check_flag'
          //   labelOn={true}
            validateCallback={this.validateCallback}
            checkedValue={1}
            uncheckedValue={undefined}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    return (
    <></>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<></>);
  }

  returnStatus(paymentData){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        values:paymentData,
      }
    }, () => { this.dialogConfirm.current.show() })
  }

  PaymentBankUpdate(paymentData){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        values:paymentData,
      }
    }, () => { this.dialogPaymentBankUpdate.current.show() })
  }

  async setAddCostDialog(paymentData){

    // 対象見積IDの見積データ取得
    const targetEstimateArr = paymentData.estimate_natural_id_ssv.split(",")

    // 対象見積データを取得する。
    const estimateList = await Promise.all(targetEstimateArr.map((estimate_natural_id) => {
      return new Promise(resolve => {
        const params = {
          estimate_natural_id : estimate_natural_id,
          extension_flag : true
        }

        Request.get("/api/order", params ,(res) => {
          resolve(res.Data[0])
        })
      })
    }))
    
    this.setState({
      estimateList : estimateList,
      dialogAddCostData:{
        ...this.state.dialogAddCostData,
        values:{
          ...paymentData,
          old_add_cost_amt : paymentData.add_cost_amt,
          old_add_cost_security_deposit_amt : paymentData.add_cost_security_deposit_amt
        },
      }
    }, () => { this.dialogAddCost.current.show() })
  }

  setAddCostConfirmDialog(paymentData){
    this.setState({
      dialogAddCostConfirmData:{
        ...this.state.dialogAddCostConfirmData,
        values:paymentData,
      }
    }, () => { this.dialogAddCostConfirm.current.show() })
  }

  validateExecCallback(newData, callback=()=>{}){
    // console.log(newData);
    // console.log(this.state.executionData);
    this.setState({
      executionData:{
        ...this.state.executionData,
        ...newData
      }
    }, ()=>callback())
  }

  convertKouzaKana(string){
    let count = 30
    let newText = string.substring(0, count).padEnd(count, " ")
    return newText
  }
  convertKouzaNum(string){
    let count = 7
    let newText = string.substring(0, count).padStart(count, "0");
    return newText
  }

  async onClickExecButton() {
//    const checked_items = await this.state.data.filter((item) => item.checked)
    var checked_items = this.state.checkedItems;
    var {exec_action,csv_export_flag} = this.state.executionData.values;
    let runData = [];
    if (checked_items.length<1) {
      return
    }
    switch (exec_action) {
      case "全銀CSV出力":
        //================================
        //LM-328 [追加要望]G101-5. 仕入
        //銀行コードのないデータはCSV出力させない機能
        // const filteredItems = checked_items.filter((item)=>{
        //   const {
        //     bank_natural_id,
        //     payment_status
        //   } = item.prop
        //   return (payment_status === 1 && bank_natural_id!==undefined && bank_natural_id!==null)
        // })

        // 仕入依頼済でマスタ未登録銀行、CSV出力済、仕入済の仕入依頼は無視されます。
        // ○　仕入依頼済（マスタ登録銀行）　→　全銀CSV出力
        if(csv_export_flag == 1){
          runData = checked_items.filter((item) => (item.prop.bank_natural_id && item.prop.bank_branch_natural_id && (item.prop.payment_status == 1 || item.prop.payment_status == 3 || item.prop.payment_status == 5 )))
        }else{
          runData = checked_items.filter((item) => (item.prop.bank_natural_id && item.prop.bank_branch_natural_id && (item.prop.payment_status == 1 || item.prop.payment_status == 5)))
        }

        const csvData = [];
        runData.forEach(item => {
          console.log(item.prop.payment_bank_account_kana)

          
          csvData.push(
            [2,
            parseInt(item.prop.bank_natural_id),
            "",
            parseInt(item.prop.bank_branch_natural_id),
            "",
            "",
            item.prop.payment_bank_account_type,
            this.convertKouzaNum(item.prop.payment_bank_account_number),
            this.convertKouzaKana(item.prop.payment_bank_account_kana),
            item.prop.payment_amt,
            "1",
            "",
            "",
            "",
            "",
            "",
            ])
        })
        ZEN_FURI.HEADER[5] = moment().format("MMDD");
        csvData.splice(0, 0, ZEN_FURI.HEADER)

        //件数
        const counts = runData.length;
        //合計金額
        const totalAmount = runData.reduce((acc, datum) => (acc + datum.prop.payment_amt), 0)

        csvData.push([8, counts, totalAmount, " ","","","","","","","","","","","",""])
        csvData.push(ZEN_FURI.END)

        this.setState({
          checked_payment:'全銀CSV出力',
          csv_export_flag: csv_export_flag,
          checkedData: checked_items,
          csvData : csvData,
          runData : runData
        },()=>{
          this.dialogPaymentConfirm.current.show()
        })
        break;

      case "全銀CSV出力(Biz)":
        // 仕入依頼済でマスタ未登録銀行、CSV出力済、仕入済の仕入依頼は無視されます。
        // 仕入依頼済（マスタ登録銀行）　→　全銀CSV出力
        if(csv_export_flag == 1){
          runData = checked_items.filter((item) => (item.prop.bank_natural_id && item.prop.bank_branch_natural_id && (item.prop.payment_status == 1 || item.prop.payment_status == 3 || item.prop.payment_status == 5)))
        }else{
          runData = checked_items.filter((item) => (item.prop.bank_natural_id && item.prop.bank_branch_natural_id && (item.prop.payment_status == 1 || item.prop.payment_status == 5) ))
        }

        //BizStation
        // let csvDataForBiz = [1,21,0,2618720300,"ｶ) ﾗﾝﾄﾞﾏ-ｸ".padEnd(40," "),moment().format("MMDD"),"0005","ﾐﾂﾋﾞｼﾕ-ｴﾌｼﾞｴｲ".padEnd(15, " "),825,"ｵｵｻｶｷﾖｳﾊﾞｼ".padEnd(15, " "),1,"9082384".padStart(7, "0"),"                 "];
        let csvDataForBiz = [1,21,0,1140417040,"ｶ) ﾗﾝﾄﾞﾏ-ｸ".padEnd(40," "),moment().format("MMDD"),"0005","ﾐﾂﾋﾞｼﾕ-ｴﾌｼﾞｴｲ".padEnd(15, " "),608,"ｱｵﾔﾏ".padEnd(15, " "),1,"5209628".padStart(7, "0"),"                 "];
        runData.forEach(item => {

          // 銀行情報取得
          const bank = this.state.bankList.find((bank) => 
          (bank.bank_natural_id === item.prop.bank_natural_id 
            && bank.bank_name === item.prop.payment_bank))

          const bank_name_kana = bank ? bank.bank_name_kana : ""

          // 銀行支店情報取得
          const bankBranch = this.state.bankBranchList.find((branch) => 
          (branch.bank_natural_id === item.prop.bank_natural_id 
            && branch.bank_branch_natural_id === item.prop.bank_branch_natural_id 
            && branch.bank_branch_name === item.prop.payment_bank_branch))

          const bank_branch_name_kana = bankBranch ? bankBranch.bank_branch_name_kana : ""

          csvDataForBiz = [
            ...csvDataForBiz,
            2,
            item.prop.bank_natural_id.padStart(4, "0"),
            bank_name_kana.padEnd(15, " "),
            item.prop.bank_branch_natural_id.padStart(3, "0"),
            bank_branch_name_kana.padEnd(15, " "),
            "    ",
            item.prop.payment_bank_account_type,
            this.convertKouzaNum(item.prop.payment_bank_account_number),
            this.convertKouzaKana(item.prop.payment_bank_account_kana),
            item.prop.payment_amt.toFixed().padStart(10, "0"),
            1,
            "          ",
            "          ",
            " ",
            " ",
            "       ",
            ]
        })

        //件数
        const countsBiz = runData.length;
        //合計金額
        const totalAmountBiz = runData.reduce((acc, datum) => (acc + datum.prop.payment_amt), 0)

        csvDataForBiz = [
          ...csvDataForBiz,
          8, countsBiz.toFixed().padStart(6, "0"), totalAmountBiz.toFixed().padStart(12, "0"), "".padStart(101, " "),
          9, "".padStart(119, " ")
        ]

        this.setState({
          checked_payment:'全銀CSV出力(Biz)',
          csv_export_flag: csv_export_flag,
          checkedData: checked_items,
          csvData : csvDataForBiz,
          runData : runData
        },()=>{
          this.dialogPaymentConfirm.current.show()
        })
        break;
      case "仕入済に":

        // 仕入依頼済でマスタ登録銀行、仕入済の仕入依頼は無視されます。よろしいですか？
        // ○　CSV出力済　　　　　　　　　　→　仕入済
        // ○　仕入依頼済（マスタ未登録銀行）→　仕入済
        runData = checked_items.filter((item) => (item.prop.payment_status == 3 || ((item.prop.payment_status == 1 || item.prop.payment_status == 5) && (!item.prop.bank_natural_id || !item.prop.bank_branch_natural_id))))
        this.setState({
          checked_payment:'仕入済に',
          checkedData: checked_items,
          runData : runData
        },()=>{
          this.dialogPaymentConfirm.current.show()
        })
        break
      case "合計金額を計算":
        this.setState({
          checked_payment:'合計金額を計算',
          checkedData: checked_items,
        },()=>{
          this.dialogPaymentConfirm.current.show()
        })
        break
      case "チェックした案件のみ表示する":
        this.setState({
          data : this.state.data.filter((item) => (item.checked))
        })
        break
      case "失注に":

        // 仕入済み、失注以外が対象
        runData = checked_items.filter((item) => (item.prop.payment_status != 4 && item.prop.payment_status != 6))
        this.setState({
          checked_payment:'失注に',
          checkedData: checked_items,
          runData : runData
        },()=>{
          this.dialogPaymentConfirm.current.show()
        })
        break
      default:
        return
    }
    // this.allStateClear();
  }

  getButtonIdByExecutionType(executionType) {
    switch(executionType){
      case "全銀CSV出力":
      return "BTN_G1_01_03320"
      case "仕入済に":
      return "BTN_G1_01_03330"
      case "合計金額を計算":
      return "BTN_G1_01_03340"
      default:
      return undefined
    }
  }

  checkbox_field_cols(){
    const buttonIdByExecutionType = this.getButtonIdByExecutionType(this.state.executionData.values.exec_action)
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
      <>
      <Col md='3'><Label for="" className="search-text-order">チェックした仕入依頼を</Label>
        <InputSelect
          label='処理'
          name='TEMP__exec_action'
          options={[
            {value:'全銀CSV出力', label:'全銀CSVを出力する'},
            {value:'全銀CSV出力(Biz)', label:'全銀CSV(Biz)を出力する'},
            {value:'仕入済に', label:'仕入済にする'},
            {value:'合計金額を計算', label:'合計金額を計算する'},
            {value:'チェックした案件のみ表示する', label:'チェックした案件のみ表示する'},
            {value:'失注に', label:'失注にする'},
          ]}
          rootData={this.state.executionData}
          validateCallback={this.validateExecCallback} 
        />
      </Col>
      <Col md='3'>
        {
          (this.state.executionData.values.exec_action == "全銀CSV出力"  || 
          this.state.executionData.values.exec_action == "全銀CSV出力(Biz)") &&
          <InputCheckBox
              label='CSV出力済も出力する'
              name='TEMP__csv_export_flag'
              validateCallback={this.validateExecCallback}
              validateType={'search'}   
              rootData={this.state.executionData}
              checkedValue={1}
              uncheckedValue={undefined}              
            />
        }

        <ButtonWithRole 
          button_id={buttonIdByExecutionType}
          onClick={this.onClickExecButton}
          className="float-right"
        >
          実行
        </ButtonWithRole>
      </Col>
      <Col md='3'>
        <ButtonWithRole 
          // button_id={"BTN_G1_01_99999"}
          onClick={() => {
            this.setState({
              dialogTitle : "仕入CSV出力"
            }, () => {
              this.dialogInvoiceCsvDownload.current.show()
            })
          }}
          className="float-right"
        >
          仕入CSV出力
        </ButtonWithRole>
      </Col>
      </>
    );
  }
  
  dialog_defines() {
    return (
      <>
        <DialogConfirm 
          ref={this.dialogConfirm}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          positive_label="はい"
          negative_label="いいえ"
          refreshCallback={(ulid)=>{this.search(true,ulid)}}
          />
        <DialogPaymentConfirm
          ref={this.dialogPaymentConfirm}
          {...this.props}
          title={this.state.checked_payment}
          csv_export_flag={this.state.csv_export_flag}
          checkedData={this.state.checkedData}
          runData={this.state.runData}
          csvData={this.state.csvData}
          positive_label="はい"
          negative_label="いいえ"
          default_footer={true}
          refreshCallback={(ulids)=>{this.search(true,"",ulids)}}
        />
        <DialogAddCost
          ref={this.dialogAddCost}
          {...this.props}
          data={this.state.dialogAddCostData}
          estimateList={this.state.estimateList}
          positive={true}
          refreshCallback={this.search}
          userlist={this.state.landmark_user}
        />
        <DialogAddCostConfirm
          ref={this.dialogAddCostConfirm}
          data={this.state.dialogAddCostConfirmData}
          positive={true}
          refreshCallback={this.search}
        />
        <DialogInvoiceCsvDownload
          ref={this.dialogInvoiceCsvDownload} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          searched_data = {this.state.searched_data}
          positive={true}
          default_footer={true}
        />
        <DialogPaymentBankUpdate
          ref={this.dialogPaymentBankUpdate}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          positive_label="更新"
          negative_label="キャンセル"
          bankList={this.state.bankListModal}
          bankBranchList={this.state.bankBranchListModal}
          refreshCallback={()=>{this.search(true)}}
        />
      </>
    );
  }    
}

export class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '差戻しますか？',
      data: this.props.data
    });
    this.memoValidateCallback = this.memoValidateCallback.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentDidUpdate(prevProps){

    if (prevProps.data !== this.props.data){
      this.setState({
        data: this.props.data
      })
    }
  }

  memoValidateCallback(newData, callback=()=>{}){
    this.setState({
      data:newData
    }, ()=>callback())
  }

  validate() {
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive(){
    if(this.validate()) {
      //差戻 url TO DO status check
      const url = 'api/payment/' + this.state.data.values.ulid;
      Request.put(url, this.state.data.values, res => {
        this.toggleModal();
        this.props.refreshCallback(this.state.data.values.ulid)
      });
    }
  }

  bodyContent() {
    return (
      <>
        <InputText multiline={true}
          label='差戻メッセージ'
          name='ESTIMATE__payment_return_memo'
          copy="false"
          validateCallback={this.memoValidateCallback} 
          rootData={this.state.data}
          validateType='regist'
        />
      </>
    );
  }
}

export class DialogPaymentConfirm extends DialogBase {
  constructor(props) {
    super(props);
    moment.locale('ja');
    const now = new Date();
    const buf = moment(now);
    const payment_finish_date = buf.format("YYYY-MM-DDT00:00:00")
    const filedate = buf.format("YYYYMMDD_HHmmss");
    this.state = {
      data:{
        values:{
          payment_finish_date
        },
        errors:{},
        requiredData:{
          payment_finish_date : [GetMessage(2024)]
        },
      },
      size : "lg"
    }
    Object.assign(this.state, {
      title: this.props.title+'します。',
      headers:[
      {
        id: 'PAYMENT__payment_bank',
        displayName: '銀行名'
        },
      {
        id: 'PAYMENT__payment_bank_branch',
        displayName:'支店名'
      },
      {
        id: 'PAYMENT__payment_bank_account_type',
        displayName:'口座種別'
      },
      {
        id: 'PAYMENT__payment_bank_account_number',
        displayName:'口座番号'
      },
      {
        id: 'PAYMENT__payment_bank_account_kana',
        displayName:'口座名義（カナ）'
      },
      {
        id: 'PAYMENT__payment_amt',
        displayName:'支払額'
      }
      ],
      filename:"ZEN_FURI_DATA_"+filedate
    });
    this.validateCallback = this.validateCallback.bind(this)
    this.validate = this.validate.bind(this)
    this.paymentDone = this.paymentDone.bind(this)
  }

  paymentDone(path='status'){
    if(this.validate()){
      const checked_data  = this.props.runData.map((item)=>{
        return {
          payment_ulid:item.prop.ulid,
          updatetimestamp : item.prop.update_timestamp,
          estimate_natural_id_ssv : item.prop.estimate_natural_id_ssv
        }
      })
      const url = '/api/payment/' + path;
      const {payment_finish_date} = this.state.data.values
      Request.put(url, {checked_data, payment_finish_date}, res => {
        if (res.Code == 816){
          this.props.alertModal.current.confirmCheck({
            title: res.data.message,
            messageNo: 2616,
            closeBtn: false
          }, ()=>{
            this.props.refreshCallback(checked_data)
          }, false)
        }else{
          this.props.refreshCallback(checked_data)
        }
      });
      // Request.put(url, {checked_data, payment_finish_date}, res => {
      //   this.props.refreshCallback(checked_data)
      // });
    }
  }
  
  validate() {
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      }
    }, ()=>callback())
  }

  componentDidUpdate(prevProps) {
    if (prevProps.title !== this.props.title){
      this.setState({
        title:"チェックした仕入依頼について"+this.props.title+'します。'
      });
    }
  }

  csvDownloadDone(){
    const csvData  = this.props.runData.map((item)=>{
      return {
        payment_ulid : item.prop.ulid,
        updatetimestamp : item.prop.update_timestamp
      }
    })
    // TODO 仕入ステータス更新API呼び出し
    const url = '/api/payment/status';
    Request.put(url, { csv_data: csvData }, res => {
      this.props.refreshCallback(csvData)
    });
  }

  downloadTxtFile = (data) => {
    const toEnc = 'sjis';
    const codes = Encoding.stringToCode(data.join(""));
    const shiftJisCodeList = Encoding.convert(codes, toEnc, 'Unicode');
    const uInt8List = new Uint8Array(shiftJisCodeList);
    const blob = new Blob([uInt8List], {type: 'text/plain'});
    const element = document.createElement("a");
    element.href = URL.createObjectURL(blob);
    element.download = `ZEN_FURI_BIZ_DATA_${moment().format("YYYYMMDD_HHmmss")}.txt`;
    document.body.appendChild(element);
    element.click();

    this.csvDownloadDone();
  }

  bodyContent() {
    let message;
    if (this.props.title==="全銀CSV出力" || this.props.title==="全銀CSV出力(Biz)"){
      message = 
        <>
          <div>{`「全銀CSV出力」処理を開始します。よろしいですか？`}</div>
          <div style={{marginTop:"10px",marginBottom:"5px",color:"red"}}>{`口座名が30文字以上の場合31文字以降の文字は切り捨てされます。`}</div>
          <div>{`以下のデータは無視されます。`}</div>
          <div>{`・仕入依頼済かつマスタ未登録銀行（手入力した銀行）`}</div>
          {this.props.csv_export_flag !== 1 &&<div>・CSV出力済</div>}
          <div>{`・仕入済`}</div>
          <div>{`・失注`}</div>
        </>
    } else if (this.props.title==="仕入済に"){
      message = 
        <>
          <div>{`「仕入済」処理を開始します。よろしいですか？`}</div>
          <div>{`以下のデータは無視されます。`}</div>
          <div>{`・仕入依頼済かつマスタに登録済みの銀行（プルダウンより選択した銀行）`}</div>
          <div>{`・仕入済`}</div>
          <div>{`・失注`}</div>
        </>
    } else if (this.props.title==="失注に"){
      message = 
        <>
          <div>{`「失注」処理を開始します。よろしいですか？`}</div>
          <div>{`以下のデータは無視されます。`}</div>
          <div>{`・仕入済`}</div>
          <div>{`・失注`}</div>
        </>
    }

    const {
      headers,
      filename
    } = this.state;
    return (
      <>
        {this.props.title==="合計金額を計算"?(
          <div>
            <span>
                支払総額：
                {
                  Format.comma_delimited(this.props.checkedData.reduce((acc, item)=>{
                    acc += isNaN(parseInt(item.prop.payment_amt))?0:parseInt(item.prop.payment_amt)
                    return acc
                  }, 0),"円")
                }
            </span>
          </div>
        ):(
          <>
            <div>{message}</div>
            <div>実行する件数　{this.props.runData.length}件　無視する件数　{this.props.checkedData.length - this.props.runData.length}件</div>
          </>
        )}
        {this.props.title === "仕入済に"?
          <>
            <br/>
            <Row>
              <Col md="12">
                <InputDatetime
                  label='仕入実施日を指定する'
                  name='PAYMENT__payment_finish_date'
                  labelOn={true}
                  validateCallback={this.validateCallback}
                  rootData={this.state.data}
                  validateType={'regist'}
                />
              </Col>
            </Row>
          </>
        :""}
        <div className="modal-box">
          <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          {this.props.title==="全銀CSV出力" && this.props.runData.length>0?(
            <CsvDownloader
              noHeader={true}
              filename={filename}
              // columns={headers}
              datas={this.props.csvData}
              separator=","
              bom={true}
            >
              <Button color="info" onClick={() => {
                  this.csvDownloadDone();
                  this.handleClickNegative();
                }}>OK
              </Button>
            </CsvDownloader>
          ):
            this.props.title==="全銀CSV出力(Biz)" && this.props.runData.length>0?(
              <Button onClick={()=>{
                    this.downloadTxtFile(this.props.csvData)
                    this.handleClickNegative()
              }} color="info" >OK</Button>
            ) : (
              <Button onClick={()=>{
                if(this.props.title === "仕入済に"){
                  if(this.validate()){
                    this.paymentDone()
                    this.handleClickNegative()
                  }
                } else if (this.props.title === "失注に") {
                  if(this.validate()){
                    console.log('exec');
                    this.paymentDone('lost_bid')
                    this.handleClickNegative()
                  }
                } else {
                  this.handleClickNegative()
                }
              }} color="info" >OK</Button>
          )}
        </div>
      </>
    );
  }
}

export class DialogAddCost extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '仕入追金を入力してください',
      payment: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      },
      estimateList : []
    });
    this.validate = this.validate.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      const {
        payment_amt,
        add_cost_amt,
        add_cost_security_deposit_amt,
      } = this.props.data.values
      this.setState({
        payment:{
          ...this.props.data,
        },
        estimateList: this.makeEstimateForRootData(this.props.estimateList),
        targetIndex : 0,

      })
    }
  }
  makeEstimateForRootData(estimateList){
    const estimateForRootData = estimateList && estimateList.map((estimate) => {

      const _CAL_add_cost_total_amt = ((estimate.quote_cost_total_amt || 0)
      + (estimate.add_cost_amt || 0)
      + (estimate.quote_cost_security_deposit_total_amt || 0)
      + (estimate.add_cost_security_deposit_amt || 0))
      + (estimate.quote_cost_adjustment || 0)

      const _CAL_all_add_cost = estimateList.reduce((acc, currentEstimate) => {
          acc = acc + currentEstimate.add_cost_amt + currentEstimate.add_cost_security_deposit_amt
        return acc
      }, 0)

      const _CAL_add_payment_amt = estimateList.reduce((acc, currentEstimate) => {
          acc = acc 
          + (currentEstimate.quote_cost_total_amt || 0)
          + (currentEstimate.add_cost_amt || 0)
          + (currentEstimate.quote_cost_security_deposit_total_amt || 0)
          + (currentEstimate.add_cost_security_deposit_amt || 0)
          + (currentEstimate.quote_cost_adjustment || 0)
        return acc
      }, 0)

//      console.log("_CAL_add_payment_amt ", _CAL_add_payment_amt)

      return {
        values : {
          ...estimate,
          _CAL_add_cost_total_amt : _CAL_add_cost_total_amt,
          _CAL_all_add_cost : _CAL_all_add_cost,
          _CAL_add_payment_amt : _CAL_add_payment_amt,
        },
        requiredData : {
          // add_cost_amt : [GetMessage(2024)],
          // add_cost_security_deposit_amt : [GetMessage(2024)],
        },
        errors : {}
      }
    })
    return estimateForRootData
  }

  validate() {
    const estimateList = this.state.estimateList;

    let messageList = []
    estimateList.forEach(estimate => {
      let messages = getErrorCodes(estimate.errors);

      if(messages.length > 0){
        messageList.push(...messages)
      }

      if(estimate.values._CAL_add_cost_total_amt < 0){
        messageList.push(2460)
      }
    })

    if(messageList.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:messageList});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    if(this.validate()) {
      const url = 'api/payment/addcost';

      // //  追金変更の場合、追金額更新担当者を更新
      let current_user = null;
      current_user = GsuiteAuth.get("id")
      const estimateData = this.state.estimateList.map((estimate) => {
        return {
          estimate_natural_id : estimate.values.estimate_natural_id,
          add_cost_amt : estimate.values.add_cost_amt,
          add_cost_security_deposit_amt : estimate.values.add_cost_security_deposit_amt,
          add_cost_memo : estimate.values.add_cost_memo,
          update_timestamp : estimate.values.update_timestamp,
          security_deposit_update_timestamp : estimate.values.security_deposit_update_timestamp,
        }
      })

      Request.put(url, { estimateData , current_user, ulid : this.state.payment.values.ulid }, res => {
        if(res.data.Code === 200){
          this.props.refreshCallback();
          this.toggleModal();
        }
      });
    } 
  }

  handleClickNegative(){
    this.toggleModal();
  }

  validateCallback(newData, callback=()=>{}){
    const updateEstimateList = this.state.estimateList.map((estimate, index)=>{
      const _CAL_add_cost_total_amt = 
            (newData.values.quote_cost_total_amt || 0)
              + (newData.values.add_cost_amt || 0)
              + (newData.values.quote_cost_security_deposit_total_amt || 0)
              + (newData.values.add_cost_security_deposit_amt || 0)
              + (newData.values.quote_cost_adjustment || 0)

      const _CAL_all_add_cost = this.state.estimateList.reduce((acc, currentEstimate) => {
        if(newData.values.estimate_natural_id === currentEstimate.values.estimate_natural_id){
          acc = acc + newData.values.add_cost_amt + newData.values.add_cost_security_deposit_amt
        } else {
          acc = acc + currentEstimate.values.add_cost_amt + currentEstimate.values.add_cost_security_deposit_amt
        }
        return acc
      }, 0)

      const _CAL_add_payment_amt = this.state.estimateList.reduce((acc, currentEstimate) => {
        
        if(newData.values.estimate_natural_id === currentEstimate.values.estimate_natural_id){
          acc = acc + _CAL_add_cost_total_amt
        } else {
          acc = acc + currentEstimate.values._CAL_add_cost_total_amt
        }
        return acc
      }, 0)

      if(index === this.state.targetIndex){
        return {
          ...newData,
          values : {
            ...newData.values,
            _CAL_add_cost_total_amt : _CAL_add_cost_total_amt,
            _CAL_all_add_cost : _CAL_all_add_cost,
            _CAL_add_payment_amt : _CAL_add_payment_amt
          }
        }
      } else {
        return {
          ...estimate,
          values : {
            ...estimate.values,
            _CAL_all_add_cost : _CAL_all_add_cost,
            _CAL_add_payment_amt : _CAL_add_payment_amt
          }
        }
      }
    })
    this.setState({
      estimateList : updateEstimateList
    })
  }

  bodyContent(){
    const {
      add_cost_update_user_id,
    } = this.state.payment.values
    const {
      userlist = []
    } = this.props


    //　追金額更新担当者
    const add_cost_update_user = userlist.find((singleUser)=>singleUser.id===add_cost_update_user_id)
    return(
      <>
        <Row>
            {this.state.estimateList.map((estimate, index)=>{
              const textDecoration  =  (index===this.state.targetIndex) ? 'underline': ''
              return <Col md="3" className="text-center">
                <div
                  style={{
                    backgroundColor: ((index==this.state.targetIndex)?'#b2dff9':'lightgrey'),
                    // display: 'inline-block',
                    // padding: '0 30px',
                    borderRadius: '10px 10px 0 0',
                    cursor:'pointer', 
                    textDecoration
                  }}
                  onClick={()=>{
                    this.setState({
                      targetIndex : index
                    })
                  }}
                >
                  {estimate.values.estimate_natural_id}
                </div>
              </Col>
            })}
          
        </Row>
        <Table>
          <tbody>
            <tr>
              <CustomTd 
                label="見積ID" 
                name="ESTIMATE__estimate_natural_id"
                copy={false}
                value={this.state.estimateList.length > 0 && 
                  (this.state.estimateList[this.state.targetIndex].values.request_type <= 3 ?
                    <a target="_blank" href={`https://drive.google.com/open?id=${this.state.estimateList[this.state.targetIndex].values.latest_pdf_survey_url}`}>{this.state.estimateList[this.state.targetIndex].values.estimate_natural_id}</a>
                  :
                    this.state.estimateList[this.state.targetIndex].values.estimate_natural_id
                  )
                }

              />
            </tr>
            <tr>
              <CustomTd 
                label="仕入金額" 
                name="ESTIMATE__quote_cost_total_amt"
                copy={false}
                value={this.state.estimateList.length > 0 && Format.comma_delimited(this.state.estimateList[this.state.targetIndex].values.quote_cost_total_amt, "円")}
              />
            </tr>
            <tr>
              <CustomTd label='仕入の追金'
                name='ESTIMATE__add_cost_amt'
                copy={false}
                rootData={this.state.estimateList[this.state.targetIndex]}
                value={
                  <InputNumber
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd 
                label="敷金" 
                name="ESTIMATE__quote_cost_security_deposit_total_amt"
                copy={false}
                value={this.state.estimateList.length > 0 && Format.comma_delimited(this.state.estimateList[this.state.targetIndex].values.quote_cost_security_deposit_total_amt, "円")}
              />
            </tr>
            <tr>
              <CustomTd label='敷金の追金'
                name='ESTIMATE__add_cost_security_deposit_amt'
                copy={false}
                rootData={this.state.estimateList[this.state.targetIndex]}
                value={
                  <InputNumber
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd 
                label="仕入金額＋仕入の追金＋敷金＋敷金の追金＋調整額"
                name="___CAL_add_cost_total_amt"
                copy={false}
                value={this.state.estimateList.length > 0 && Format.comma_delimited(this.state.estimateList[this.state.targetIndex].values._CAL_add_cost_total_amt, "円")}
              />
            </tr>
            <tr>
              <CustomTd 
                label="追金合計" 
                name="___CAL_all_add_cost"
                copy={false}
                value={this.state.estimateList.length > 0 && Format.comma_delimited(this.state.estimateList[this.state.targetIndex].values._CAL_all_add_cost, "円")}
              />
            </tr>
            <tr>
              <CustomTd 
                label="支払金額＋追金合計" 
                name="___CAL_add_payment_amt"
                copy={false}
                value={this.state.estimateList.length > 0 && Format.comma_delimited(this.state.estimateList[this.state.targetIndex].values._CAL_add_payment_amt, "円")}
              />
            </tr>
            <tr>
              <CustomTd label='業務部からの追金メモ'
                name='ESTIMATE__add_cost_memo'
                copy={false}
                rootData={this.state.estimateList[this.state.targetIndex]}
                value={
                  <InputText 
                    multiline={true}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd 
                label="追金額更新担当者" 
                name="PAYMENT__add_cost_update_user_id"
                copy={false}
                value={add_cost_update_user ? add_cost_update_user.label : ""}
              />
            </tr>
          </tbody>
        </Table>
        <hr />
      </>
    );
  }
}

export class DialogAddCostConfirm extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '仕入追金を確認済にします。よろしいですか？',
      payment: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(this.props) === JSON.stringify(prevProps))
      return;

    this.setState({
      payment:this.props.data
    })
  }

  handleClickPositive() {
    const url = 'api/payment/confirmaddcost';
    Request.put(url, this.state.payment.values, res => {
      this.props.refreshCallback();
      this.toggleModal();
    });
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(<></>);
  }
}

export class DialogInvoiceCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.getPaymentCsv = this.getPaymentCsv.bind(this)
    this.validateCallback = this.validateCallback.bind(this)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: this.props.dialogTitle+'をします。よろしいですか？',
        dialogData : {
          values : {
            payment_finish_date_from : moment().format("YYYY-MM-DDT00:00:00"),
            payment_finish_date_to : moment().format("YYYY-MM-DDT23:59:59"),
          },
          errors: {
            // ...this.state.dialogData.errors
          }, 
          requiredData :{
            payment_finish_date_from:[GetMessage(2024)],
            payment_finish_date_to:[GetMessage(2024)],
          }
        }
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  getPaymentCsv(){
    return new Promise(async (resolve, reject) => {
      Request.get(`/api/payment/csv`, { ...this.state.dialogData.values } , res => {
        const csvData = this.makeCsv(res.Data)
        resolve({"csvData":csvData, "invoiceDataCheck":this.checkCsvData(res.Data)})
      })
    })
  }
  checkCsvData (csvData) {
    for( let i = 0; i < csvData.length; i ++){

      let {
        supplier_invoice_business_type,
        supplier_invoice_registration_number,
        survey_cost_parking_rent_payment_type,
        survey_cost_parking_rent_invoice_business_type,
        survey_cost_parking_rent_invoice_registration_number,
        survey_cost_commission_payment_type,
        survey_cost_commission_invoice_business_type,
        survey_cost_commission_invoice_registration_number,
        survey_cost_key_money_payment_type,
        survey_cost_key_money_invoice_business_type,
        survey_cost_key_money_invoice_registration_number
      } = csvData[i]

      if (survey_cost_parking_rent_payment_type == null || 
        survey_cost_commission_payment_type == null || 
        survey_cost_key_money_payment_type == null ||
        survey_cost_parking_rent_invoice_business_type == null || 
        survey_cost_commission_invoice_business_type == null || 
        survey_cost_key_money_invoice_business_type == null) 
      {
        return true
      }

      // 区分→仕入先の設定が1つでもある場合は、仕入先情報の適格事業者情報をチェック
      if (survey_cost_parking_rent_payment_type == 0 || 
        survey_cost_commission_payment_type == 0 || 
        survey_cost_key_money_payment_type == 0) 
      {
        if (supplier_invoice_business_type == null || supplier_invoice_business_type == 0) {
          return true
        }
        else if (supplier_invoice_business_type == 1 && (supplier_invoice_registration_number == "" || supplier_invoice_registration_number == null)) {
          return true
        }
      }
      // 手数料仕入先：区分→その他、適格事業者、番号非登録
      if (survey_cost_commission_payment_type == 1 && (
        (survey_cost_commission_invoice_business_type == 1 && 
        (survey_cost_commission_invoice_registration_number == null || survey_cost_commission_invoice_registration_number == "")) ||
        (survey_cost_commission_invoice_business_type == 0 || survey_cost_commission_invoice_business_type == null) )
      ) {
        return true
      }
      // 礼金仕入先：区分→その他、適格事業者、番号非登録
      if (survey_cost_key_money_payment_type == 1 && (
        (survey_cost_key_money_invoice_business_type == 1 && 
        (survey_cost_key_money_invoice_registration_number == null || survey_cost_key_money_invoice_registration_number == "")) ||
        (survey_cost_key_money_invoice_business_type == 0 || survey_cost_key_money_invoice_business_type == null)
      )) {
        return true
      }
      // 賃料仕入先：区分→その他、適格事業者、番号非登録
      if (survey_cost_parking_rent_payment_type == 1 && (
        (survey_cost_parking_rent_invoice_business_type == 1 && 
        (survey_cost_parking_rent_invoice_registration_number == null || survey_cost_parking_rent_invoice_registration_number == "")) ||
        (survey_cost_parking_rent_invoice_business_type == 0 || survey_cost_parking_rent_invoice_business_type == null)
      )) {
        return true
      }
    }

    return false
  }
  map_invoice_data (data, param, output="payment_type") {
    let payment_type = data[param+"_payment_type"]
    switch (payment_type) {
      // 区分：仕入先
      case 0:{
        if (data["supplier_invoice_business_type"] == null || data["supplier_invoice_registration_number"] == null) return "未登録"
        switch (output) {
          case "payment_type": {
            return FormatCode.decode("cst_invoice_payment_type",payment_type)
          }
          case "business_type": {
            return FormatCode.decode("cst_invoice_business_type",data["supplier_invoice_business_type"])
          }
          case "registration_number": {
            return data["supplier_invoice_registration_number"]
          }
        }
      }
      // 区分：その他
      case 1:{
        let business_type = data[param+"_invoice_business_type"]
        if (business_type == null || data[param+"_invoice_registration_number"] == null) return "未登録"

        switch (output) {
          case "payment_type": {
            return FormatCode.decode("cst_invoice_payment_type",payment_type)
          }
          case "business_type": {
            return FormatCode.decode("cst_invoice_business_type",business_type)
          }
          case "registration_number": {
            return data[param+"_invoice_registration_number"]
          }
        }
      }
      default:{
        return "未登録"
      }
    }
  }

  makeCsv(payments){
    const csvData = payments.reduce((acc, data) => {
      acc.push([
        this.isNullOrUndefined(data.estimate_natural_id) ? "" : data.estimate_natural_id,
        this.isNullOrUndefined(data.payment_finish_date) ? "" : moment(data.payment_finish_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.user_branch_name) ? "" : data.user_branch_name,
        this.isNullOrUndefined(data.customer_name) ? "" : data.customer_name,
        this.isNullOrUndefined(data.customer_branch_name) ? "" : data.customer_branch_name,
        this.isNullOrUndefined(data.customer_user_name) ? "" : data.customer_user_name,
        this.isNullOrUndefined(data.construction_number) ? "" : data.construction_number,
        (FormatCode.decode("prefecture",data.site_prefecture)
        + (this.isNullOrUndefined(data.site_city) ? "" : data.site_city)
        + (this.isNullOrUndefined(data.site_address) ? "" : data.site_address)),
        this.isNullOrUndefined(data.site_name) ? "" : data.site_name,
        this.isNullOrUndefined(data.quote_available_start_date) ? "" : moment(data.quote_available_start_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.quote_available_end_date) ? "" : moment(data.quote_available_end_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.payment_user_memo) ? "" : data.payment_user_memo,
        // 2023/08/28 インボイス対応
        this.map_invoice_data(data,"survey_cost_parking_rent","payment_type"),
        this.map_invoice_data(data,"survey_cost_parking_rent","business_type"),
        this.map_invoice_data(data,"survey_cost_parking_rent","registration_number"),
        this.map_invoice_data(data,"survey_cost_commission","payment_type"),
        this.map_invoice_data(data,"survey_cost_commission","business_type"),
        this.map_invoice_data(data,"survey_cost_commission","registration_number"),
        this.map_invoice_data(data,"survey_cost_key_money","payment_type"),
        this.map_invoice_data(data,"survey_cost_key_money","business_type"),
        this.map_invoice_data(data,"survey_cost_key_money","registration_number"),
        this.isNullOrUndefined(data.payment_amt) ? 0 : data.payment_amt,
        this.isNullOrUndefined(data.payment_estimate_amt) ? 0 : data.payment_estimate_amt,
        this.isNullOrUndefined(data.quote_total_amt) ? 0 : data.quote_total_amt,
        this.isNullOrUndefined(data.supplier_name) ? "" : data.supplier_name,
        this.isNullOrUndefined(data.payment_bank_account_number) ? "" : data.payment_bank_account_number,
        this.isNullOrUndefined(data.supplier_tel) ? "" : data.supplier_tel,
        this.isNullOrUndefined(data.survey_parking_name) ? "" : data.survey_parking_name,
        this.isNullOrUndefined(data.quote_capacity_qty) ? 0 : data.quote_capacity_qty,
        this.isNullOrUndefined(data.quote_cost_total_amt) ? 0 : data.quote_cost_total_amt,
        this.isNullOrUndefined(data.quote_cost_adjustment) ? 0 : data.quote_cost_adjustment,
        this.isNullOrUndefined(data.add_cost_amt) ? 0 : data.add_cost_amt,
        this.isNullOrUndefined(data.quote_cost_security_deposit_total_amt) ? 0 : data.quote_cost_security_deposit_total_amt,
        this.isNullOrUndefined(data.add_cost_security_deposit_amt) ? 0 : data.add_cost_security_deposit_amt,
        this.isNullOrUndefined(data.due_day_rule) ? "" : data.due_day_rule,
        this.isNullOrUndefined(data.payment_type) ? "" : data.payment_type,
      ])
      return acc
    }, [[...PAYMENT_CSV.HEADER]])
    return this.wrappingQuote(csvData);
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      <>
        <Row>
          <Col md="6">
            <InputDatetime
              label='仕入実施日（FROM）'
              name='PAYMENT__payment_finish_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              validateType={'search'}
            />
          </Col>
          <Col md="6">
            <InputDatetime
              label='仕入実施日（TO）'
              name='PAYMENT__payment_finish_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              validateType={'search'}
            />
          </Col>
        </Row>
        <div className="modal-box">
          <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            if(!this.validate()){
              return;
            }
            const csvData = await this.getPaymentCsv();
            console.log(csvData);
            this.setState({
              csvData : csvData.csvData,
              invoiceDataCheck:  csvData.invoiceDataCheck
            }, () => {
              if ( this.state.invoiceDataCheck ) {
                this.props.alertModal.current.confirmCheck({message:"適格事業者情報が登録されていない支払先があります。仕入CSV出力をします。よろしいですか？"},()=>{
                  this.csvDownloader.current.handleClick()
                  this.handleClickNegative();
                })
              }
              else {
                this.csvDownloader.current.handleClick()
                this.handleClickNegative();
              }
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`payment_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

export class DialogPaymentBankUpdate extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '支払先を更新しますか？',
      data: this.props.data,
      bankList: this.props.bankList,
      bankBranchList: [],
    });
    this.validateCallback = this.validateCallback.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentDidUpdate(prevProps){

    if (prevProps.data !== this.props.data){
      this.setState({
        data: this.props.data
      })
    }
    if (prevProps.bankList !== this.props.bankList){
      this.setState({
        bankList: this.props.bankList
      })
    }
    if (prevProps.bankBranchList !== this.props.bankBranchList){
      this.setState({
        bankBranchList: this.props.bankBranchList
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    const {
      bank_branch_natural_id: new_bank_branch_natural_id,
      bank_natural_id: new_bank_natural_id,
      payment_bank_account_kana
    } = newData.values

    const didBankChanged = newData.values.bank_natural_id != this.state.data.values.bank_natural_id

    const bank = this.state.bankList.find((element)=>element.value==new_bank_natural_id)
    const payment_bank = bank ? bank.label : new_bank_natural_id
    const bank_branch = didBankChanged ? null : (this.state.bankBranchList.find((element)=> (bank && bank.value == element.bank_natural_id && element.value==new_bank_branch_natural_id)))
    const payment_bank_branch = didBankChanged ? null : (bank_branch ? bank_branch.label : new_bank_branch_natural_id)
    const bank_natural_id = new_bank_natural_id
    const bank_branch_natural_id = didBankChanged ? null : new_bank_branch_natural_id

    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values:{
          ...newData.values,
          payment_bank_account_kana : payment_bank_account_kana
        }
      }
    }, ()=>this.setState({
      data:{
        ...this.state.data,
        values:{
          ...newData.values,
          bank_branch_natural_id,
          bank_natural_id,
          payment_bank_branch,
          payment_bank,
          payment_bank_account_kana : payment_bank_account_kana
        }
      }
    }))
  }

  validate() {
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive(){
    if(this.validate()) {
      //差戻 url TO DO status check
      const url = 'api/payment/' + this.state.data.values.ulid;
      const data = {
        ...this.state.data.values,
        payment_update: 1
      }
      Request.put(url, data, res => {
        this.toggleModal();
        this.props.refreshCallback(this.state.data.values.ulid)
      });
    }
  }

  bodyContent() {
    // console.log(this.state.data)
    const selectableBankBranch = this.state.data.values.bank_natural_id ? this.state.bankBranchList.filter(element=>element.bank_natural_id==this.state.data.values.bank_natural_id) : []

    return (
      <>
            <Row className="detail">
              <Col md="12" className="text-center">
                <Table>
                  <tbody>
                    <tr>
                      {/* <th rowSpan="7">支払情報</th> */}
                      <CustomTd label='銀行名'
                          name='PAYMENT__bank_natural_id'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputSelect
                              disabled={this.state.data.values.payment_type != "0"}
                              options={this.state.bankList}
                              validateCallback={this.validateCallback}
                              validateType='regist'
                              isSearchable={true}
                              isCreatable={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='支店名'
                          name='PAYMENT__bank_branch_natural_id'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputSelect
                              key={`bank-branch-${this.state.data.values.bank_natural_id}`}
                              disabled={this.state.data.values.payment_type != "0"}
                              options={selectableBankBranch}
                              validateCallback={this.validateCallback}
                              validateType='regist'
                              isSearchable={true}
                              isCreatable={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座名義（カナ）'
                          name='PAYMENT__payment_bank_account_kana'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              disabled={this.state.data.values.payment_type != "0"}
                              validateCallback={this.validateCallback}
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座種別'
                        name='PAYMENT__payment_bank_account_type'
                        copy={false}
                        rootData={this.state.data}
                        value={
                          <InputSelect
                            disabled={this.state.data.values.payment_type != "0"}
                            options={cst_payment_bank_account_type}
                            validateCallback={this.validateCallback}
                            validateType='regist'
                            isSearchable={true}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座番号'
                        name='PAYMENT__payment_bank_account_number'
                        copy={false}
                        rootData={this.state.data}
                        value={
                          <InputText
                            disabled={this.state.data.values.payment_type != "0"}
                            validateCallback={this.validateCallback}
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                  </tbody>
                </Table>
            </Col>
          </Row>
      </>
    );
  }
}

export default List;